import { createSlice } from '@reduxjs/toolkit';

/**
 * Estado de la campana de avisos en tiempo real.
 *
 * Vive en su propio slice, y no dentro de `user`, por una razón concreta: `user`
 * está en el whitelist de `redux-persist`, así que un slice ahí se persiste. Con
 * `notify: true` como valor inicial, eso dejaba la campana encendida para
 * siempre a todo usuario que recargara la página. Al ser un aviso simple (sin
 * historial ni "marcar como leídas"), el estado correcto es efímero: se enciende
 * cuando llega un evento y se apaga al pulsarla.
 */
export const realtimeSlice = createSlice({
  name: 'realtime',
  initialState: {
    notify: false,
  },
  reducers: {
    setNotify: (state, { payload }) => {
      state.notify = payload;
    },
    cleanNotify: (state) => {
      state.notify = false;
    },
  },
});

export const { setNotify, cleanNotify } = realtimeSlice.actions;

export default realtimeSlice.reducer;